const MESSAGE_TYPE = {
  CHAT_REQUEST_SUCCESS: "ChatRequestSuccess",
  QUEUE_UPDATE: "QueueUpdate",
  CHAT_ESTABLISHED: "ChatEstablished",
  CHAT_ENDED: "ChatEnded",
  AGENT_TYPING: "AgentTyping",
  AGENT_NOT_TYPING: "AgentNotTyping",
  CHAT_MESSAGE: "ChatMessage",
  CHAT_REQUEST_FAIL: "ChatRequestFail"
};
const CHAT_STATUS = {
  DEFAULT: "chat",
  ENDING: "ending",
  ENDED: "ended",
  FINAL: "final",
  CALL_CENTER_CLOSED: "noqueue-callcenter-closed",
  ADVISOR_BUSY: "noqueue-advisors-busy",
  QUEUE: "queue",
  LEAVING_QUEUE: "leaving-queue",
  NO_CASE_CODE: "no-case-code"
};
module.exports = {
  MESSAGE_TYPE,
  CHAT_STATUS
};